import { t } from '@lingui/core/macro'
import ECharts from '~/components/echarts'
import { awsSummaryChartOrganizationOptimizerAWSMasterOptimizationsPath } from '~/routes'

export default function OptimizationSummary({ organizationId, masterOptimizationId, masterOptimization }) {
  if (!masterOptimization) {
    return null
  }

  return (
    <div className='row mb-4'>
      <div className='col-md-12'>
        <div className='card-body'>
          <ECharts
            title={t`Optimization Summary`}
            chartInfoTitle='aws_master_optimization_summary'
            url={awsSummaryChartOrganizationOptimizerAWSMasterOptimizationsPath(organizationId)}
            params={{ master_optimization_id: masterOptimizationId }}
          />
        </div>
      </div>
    </div>
  )
}
